
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ScanService {
  private apiUrl = 'http://localhost:3000/api/scans';  

  constructor(private http: HttpClient) {}

  
  getScans(): Observable<any> {
    return this.http.get(this.apiUrl);
  }

  
  updateBarcode(scanId: string, barcode: string): Observable<any> {
    return this.http.put(`${this.apiUrl}/${scanId}`, { barcode });
  }
}
